import React, { useState, useEffect } from 'react';
import SEARCH_STORE_CONSTANTS from '../Constants/SearchStoreConstants';
import ImageComponent from '../../../atoms/Image/Container/ImageComponent';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import {
  getValueOrDefaultAlternativeObject,
  getAndCheck,
  getTernaryValue,
  emptyFunction,
} from 'common/utilities/utils';
import { UserOrderContext } from 'context/context';
import { TYPE_DELIVERY } from 'common/constants/SharedConstants';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';

const MyMapComponent = props => {
  const {
    locationAlertProp,
    negativeScenarioAlertProp,
    isMobile,
    onPositionChangeHandler,
    centerIndex,
    isVisible,
    setShowCard,
    locationAlert,
    setStoreMarker = emptyFunction,
    passAddress,
    storeCardHeight,
    latLongValue,
  } = props;
  const { PLACE_PIN } = SEARCH_STORE_CONSTANTS;
  const { userOrderState } = React.useContext(UserOrderContext);
  const { dispositionStateData = {} } = userOrderState;
  const { dispositionType = localStorage.getItem('dispositionType') } = dispositionStateData;
  let googleMapRef = React.createRef();
  let googleMap;
  let marker;
  const [center, setCenter] = useState(latLongValue);
  const [zoomChanged, setZoomChanged] = useState(false);
  const { RedMarker, RedMarkerNoText, BlackMarker, ArrowIcon } = IMAGE_PATH;
  /* creating a google map & marker instance by default passing latLong */
  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    googleMap = createGoogleMap(center);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    marker = createMarker(center);
  }, []);

  /* useEffect called on LatLong values changed in input box through props */
  useEffect(() => {
    setCenter(latLongValue);
    setZoomChanged(false);
  }, [latLongValue]);

  /* useEffect called on LatLong values changed through setState */
  useEffect(() => {
    createGoogleMap(center);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    marker = createMarker(center);
  }, [center, centerIndex, zoomChanged]);

  /* creating google map */
  const createGoogleMap = centerInfo => {
    return new window.google.maps.Map(googleMapRef.current, {
      zoom: 10,
      center: Array.isArray(centerInfo) && centerInfo.length > 0 ? centerInfo[centerIndex] : centerInfo,
      disableDefaultUI: true,
      fullscreenControl: false,
      zoomControl: !isMobile,
      gestureHandling: 'greedy',
    });
  };

  /* red marker with text or without text check */
  const checkRedMarker = () => {
    return dispositionType?.toUpperCase() === TYPE_DELIVERY ? RedMarkerNoText : RedMarker;
  };

  /* marker click event */
  const addListenerOnMarker = actMarker => {
    actMarker.addListener('click', function (param) {
      setStoreMarker(param.latLng);
    });
  };
  /* creating marker */
  const createMarker = centerValue => {
    const geocoder = new window.google.maps.Geocoder();
    let tempCenter = centerValue;
    googleMap = createGoogleMap(tempCenter);

    if (!isVisible) {
      /* drag event for map */
      /* istanbul ignore next */
      googleMap.addListener('drag', () => {
        tempCenter = { lat: googleMap.getCenter().lat(), lng: googleMap.getCenter().lng() };
        marker.setPosition(tempCenter); // set marker position to map center
      });
      /* dragend event for map */
      window.google.maps.event.addListener(googleMap, 'dragend', function () {
        geocodeLatLng(geocoder, googleMap, tempCenter);
      });
    } else if (!zoomChanged) {
      /* zoom event for map */
      /* istanbul ignore next */
      googleMap.addListener('zoom_changed', () => {
        setShowCard(false);
        setZoomChanged(true);
      });
      googleMap.addListener('drag', () => {
        setShowCard(false);
        setZoomChanged(true);
      });
    }
    const centerInfo = getTernaryValue(Array.isArray(tempCenter) && tempCenter.length > 0, tempCenter, [tempCenter]);
    let markerInstance = centerInfo.map((b, index) => {
      let markersCluster = new window.google.maps.Marker({
        position: b,
        map: googleMap,
        visible: true,
        icon: getValueOrDefaultAlternativeObject(!isVisible, !zoomChanged && isVisible && index === centerIndex)
          ? checkRedMarker()
          : BlackMarker,
      });
      addListenerOnMarker(markersCluster);
      return markersCluster;
    });
    return getTernaryValue(Array.isArray(tempCenter), markerInstance, markerInstance[0]);
  };

  /* called on Dragend of map to find the address of the Marker  */
  /* istanbul ignore next */
  function geocodeLatLng(geocoder, map, latlng) {
    geocoder.geocode({ location: latlng }, (results, status) => {
      if (status === 'OK') {
        if (results[0]) {
          passAddress(results[0].formatted_address);
        }
      }
    });
  }
  const showPinElement = () => {
    return dispositionType?.toUpperCase() === TYPE_DELIVERY &&
      (negativeScenarioAlertProp === '' || !negativeScenarioAlertProp) ? (
      <div className={`map-top-note ${getTernaryValue(locationAlert, 'place-pin-off', '')}`}>
        <div className='map-top-note-text' data-testid='map-top-text-test'>
          {translateWithI18Next(PLACE_PIN)}
        </div>
      </div>
    ) : null;
  };

  return (
    <React.Fragment>
      {!locationAlertProp && showPinElement()}
      {isMobile && !zoomChanged && (
        <div className='arrows' style={{ bottom: `${storeCardHeight + 15}px` }}>
          <span
            className={`map-arrow-left ${getAndCheck(centerIndex === 0, 'disableArrow')}`}
            data-testid='map-arrow-left'
            onClick={e => getTernaryValue(centerIndex === 0, e.preventDefault(), onPositionChangeHandler(0))}
          >
            <ImageComponent srcFile={ArrowIcon} alt={'map-arrow-left'} />
          </span>
          <span
            className={`map-arrow-right ${centerIndex === center.length - 1 && 'disableArrow'}`}
            data-testid='map-arrow-right'
            onClick={e => (centerIndex === center.length - 1 ? e.preventDefault() : onPositionChangeHandler(1))}
          >
            <ImageComponent srcFile={ArrowIcon} alt={'map-arrow-right'} />
          </span>
        </div>
      )}
      <div id='google-map' ref={googleMapRef}></div>
    </React.Fragment>
  );
};
export default MyMapComponent;
